import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import { Button, Box, Typography } from '@material-ui/core'
import { ArrowBackIos, ArrowForwardIos } from '@material-ui/icons'
import { getWizardSteps } from '../pages/EditPage'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { ExperienceType } from '../types/vmdata'

const useStyles = makeStyles(() =>
  createStyles({
    content: {
      position: 'relative',
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
    },
    contentWithOneBtn: {
      justifyContent: 'center',
    },
    btn: {
      padding: '0.5rem 2rem',
    },
    btnText: {
      fontSize: '1.35rem',
      fontWeight: 500,
    },
  })
)

interface WizardStepperFooterProps {
  isValid: boolean
  isNewProduct?: boolean
  children?: React.ReactNode
}

export const WizardStepperFooter: React.FC<WizardStepperFooterProps> = ({
  isValid,
  isNewProduct,
  children,
}) => {
  const styles = useStyles()
  const { pathname } = useLocation()
  const { step } = useParams<{ step: string }>()
  const path = pathname.substring(
    0,
    step ? pathname.indexOf(encodeURI(step)) - 1 : pathname.length
  )

  const navigate = useNavigate()

  const expType = useSelector((s) => s.vmData.expType)
  const steps = getWizardSteps(expType as ExperienceType)
  const wizardActiveIndex = steps.findIndex((wizard) => wizard.step === step)

  const handleNext = () => {
    const nextStep = steps[wizardActiveIndex + 1].step
    // history(match.path.replace(':step', nextStep), { replace: true })
    navigate(`${path}/${nextStep}`, { replace: true })
  }

  const handleBack = () => {
    const previousStep = steps[wizardActiveIndex - 1].step
    // history(match.path.replace(':step', previousStep), { replace: true })
    navigate(`${path}/${previousStep}`, { replace: true })
  }

  return (
    <Box
      className={`${styles.content} ${
        (wizardActiveIndex === 0 && styles.contentWithOneBtn) || ''
      }`}
    >
      {wizardActiveIndex !== 0 && (
        <Button
          variant="contained"
          disabled={wizardActiveIndex === 0}
          onClick={handleBack}
          className={styles.btn}
        >
          <ArrowBackIos />
          <Typography className={styles.btnText}>prev</Typography>
        </Button>
      )}
      {!!children && children}
      <Button
        color={wizardActiveIndex === steps.length - 2 ? 'primary' : 'secondary'}
        variant="contained"
        onClick={handleNext}
        disabled={wizardActiveIndex === steps.length - 1 || !isValid}
        className={styles.btn}
      >
        <Typography className={styles.btnText}>
          {wizardActiveIndex === steps.length - 2
            ? isNewProduct
              ? 'generate'
              : 'modify'
            : 'next'}
        </Typography>
        <ArrowForwardIos />
      </Button>
    </Box>
  )
}
